import React from 'react'
import { NavLink } from 'react-router-dom'
import "./Projects.css"

const Projects = () => {
  return (
    <div className='projects container-fluid'>
        <div className="row flex-wrap">
            <NavLink to='http://61.246.5.10/scada-nuh/index' className="project-button">
              <h1>NUH PHED</h1>
            </NavLink>
            <NavLink to='http://61.246.5.10/bakewar/' className="project-button">
              <h1>Bakewar</h1>
            </NavLink>
            <NavLink to='http://61.246.5.10/ekdil/homeoht' className="project-button">
              <h1>Ekdil</h1>
            </NavLink>
            <NavLink to='http://61.246.5.10/dohrighat/' className="project-button">
              <h1>Dohrighar</h1>
            </NavLink>
            <NavLink to='http://61.246.5.10/vijaygarh/' className="project-button">
              <h1>Vijaygarh</h1>
            </NavLink>
        </div>
           
    </div>
  )
}

export default Projects
